<template>
  <div>
    <div class="intro-y w-full box py-4 text-center text-lg mt-8">
      <h4>{{ props.tokenExpireText }}</h4>
      <div>
        ลิ้งค์ได้รับจากทางอีเมล ไม่สามารถใช้งานได้ กรุณาเข้าสู่ระบบโดยการ Login
        คลิกที่ปุ่มด้านล่าง
      </div>
      <router-link class="btn btn-primary mt-3 px-12" :to="{ name: 'login' }"
        >Login</router-link
      >
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'try-login',
  props: {
    tokenExpireText: String
  },
  setup(props) {
    return {
      props
    }
  }
})
</script>
